import LevelTag from 'components/shared/LevelTag/LevelTag'
import Progress from 'components/shared/Progress/Progress'
import { themeClassName } from 'helpers/Project'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'

import './PathwayCard.scss'

export const PathwayCard = ({
  locale,
  pathway,
  translateTitle = true,
  translateDescription = true,
  t,
}) => {
  const cardTitle = translateTitle ? t(pathway.title) : pathway.title
  const cardSubtitle = translateTitle ? t(pathway.subtitle) : pathway.subtitle
  const cardDescription = translateDescription
    ? t(pathway.description)
    : pathway.description

  return (
    <div className={`c-pathway-card ${themeClassName(pathway.color)}`}>
      <Link
        className="c-pathway-card__link"
        to={`/${locale}${pathway.linkUrl}`}
      >
        <img alt="" className="c-pathway-card__image" src={pathway.heroImage} />
        <div className="c-pathway-card__content">
          <LevelTag
            className={'c-pathway-card__level-tag'}
            level={`${pathway.difficultyLevel}`}
            technology={pathway.technologyTheme}
          />
          <h2 className={'c-pathway-card__title'}>{cardTitle}</h2>
          {cardSubtitle && (
            <h3 className={'c-pathway-card__subtitle'}>{cardSubtitle}</h3>
          )}
          <p className="c-pathway-card__description">{cardDescription}</p>
          <Progress progress={pathway.progress} />
        </div>
      </Link>
    </div>
  )
}

PathwayCard.propTypes = {
  locale: PropTypes.string.isRequired,
  pathway: PropTypes.object.isRequired,
  translateTitle: PropTypes.bool,
  translateDescription: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

export default translate('translations')(PathwayCard)
